import { useState } from 'react';
import { CreateUserPayload, usersService } from '../../../apiServices/users.service';

export const useCreateUser = () => {
  const [loading, setLoading] = useState(false);

  const createUser = async (payload: CreateUserPayload) => {
    setLoading(true);

    try {
      return await usersService.insert(payload);
    } finally {
      setLoading(false);
    }
  };

  return {
    createUser,
    loading,
  };
};
